// @ts-strict-ignore
import {EventDefinition, EventParams, MpEvent, PropertyDefinition, PropertyParams} from 'common/util/definitions-types';
import {PropertyType} from 'common/report/constants';
import {CurrentProject} from 'common/report/model-resources/projects';
import {ProjectDetails} from 'common/report/stores/project-details';

// @ts-check
import {getProjectId, getWorkspaceId} from '../report/util';
import {eventDefinitionsClient} from '../report/queries/app-api/event-definitions-client';
import {propertyDefinitionsClient} from '../report/queries/app-api/property-definitions-client';

function fetchDefinitions(
  queryClient,
  params: EventParams | PropertyParams = {},
  options: Record<string, any> = {},
): Promise<any> {
  const projectId = params.projectId || getProjectId();
  const workspaceId = params.workspaceId || getWorkspaceId();
  return queryClient.query({...params, projectId, workspaceId}, options);
}

export async function fetchEventDefinitions(
  params: EventParams = {},
  options: Record<string, any> = {},
): Promise<EventDefinition[]> {
  return fetchDefinitions(eventDefinitionsClient, params, options);
}

export function fetchPropertyDefinitions(
  params: PropertyParams,
  options: Record<string, any> = {},
): Promise<PropertyDefinition | PropertyDefinition[]> {
  return fetchDefinitions(propertyDefinitionsClient, params, options);
}

export function getDefinitionForEvent(mpEvent: MpEvent, eventDefinitions: EventDefinition[]): EventDefinition | null {
  let predicate = (definition) => {
    return (
      (definition.name === mpEvent.name || definition.name === mpEvent.value) &&
      !definition.collectEverythingEventId &&
      !definition.customEventId
    );
  };
  if (mpEvent.is_collect_everything_event) {
    predicate = (definition) => definition.collectEverythingEventId === mpEvent.id;
  } else if (mpEvent.custom) {
    predicate = (definition) => definition.customEventId === mpEvent.id;
  }

  const eventDefinition = eventDefinitions.find(predicate);
  return eventDefinition ? eventDefinition : null;
}

export function getDefinitionForProperty(
  {
    name,
    customPropertyId,
    dataGroupId,
  }: {
    name: string;
    customPropertyId?: string;
    dataGroupId?: string;
  },
  propertyDefinitions: PropertyDefinition[],
): PropertyDefinition | null {
  let propertyDefinition = propertyDefinitions.find((definition) => {
    const definitionIsCustom = definition.status === `custom`;
    const propertyIsCustom = !!customPropertyId;
    // both need to be custom or non-custom at the same time
    if (definitionIsCustom === propertyIsCustom) {
      if (definitionIsCustom) {
        return definition.customPropertyId.toString() === customPropertyId.toString();
      }
      return definition.name === name;
    }
    return false;
  });

  if (propertyDefinition && dataGroupId) {
    propertyDefinition = {
      ...propertyDefinition,
      type: PropertyType.Dimension,
      dimension_data_group_id: dataGroupId,
    };
  }

  return propertyDefinition ? propertyDefinition : null;
}

export function isLexiconEventImagesEnabled(_currentProject?: CurrentProject | ProjectDetails): boolean {
  return true;
}
